module.exports = __webpack_public_path__ + "static/img/erm4.7f75641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/erm4.png
// module id = IIYU
// module chunks = 37